import React, { Fragment, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import {
    getTermsConditionKeyValue,
    getWarehouseKeyValueDetailsList,
    getInterStateTaxKeyValueList,
    getIntraStateTaxKeyValueList,
    ItemListByWarePrice1,
    getVendorDetails,
    getPurchaseDetails,
    updatePurchaseOrder,
    addPurchaseOrder,
    addDirectBillRecord1,
    addBillOrder,
    getVendorByWare,
} from "../../../services/index";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";

const defaultItemBatchDetails = {
    batchQuantity: 0,
    batchNumber: "",
    batchManufacturingDate: "",
    batchExpiredDate: "",
    rack: "",
    cell: "",
};

const PurchaseNew = ({ componentType }) => {
    let location = useLocation();

    let orgDetail = JSON.parse(localStorage.getItem("orgDetail"));
    let orgState = orgDetail?.beanAddress?.state;
    let directBill = location?.state?.directBill;
    let { id } = useParams();
    let billId;
    if (location.state === "bill") {
        billId = id;
    }
    let navigate = useNavigate();
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);

    const [purchaseInfo, setPurchaseInfo] = useState({
        vendor: "",
        warehouse: "",
        taxType: "",
        reference: "",
        orderDate: date1,
        shipDate: date1,
        invoiceNumber: "",
        invoiceDate: date1,
        notes: "",
        terms: "",
        subTotal: 0.0,
        total: 0.0,
        shipCharge: "",
        netShip: 0.0,
        netTax: 0,
        shipTax: "",
        tcsRate: "",
    });

    const tempRows = {
        item: {
            value: "",
            label: "",
        },
        // billBatchBeansList: [defaultItemBatchDetails],
        quantity: 1,
        taxes: "",
        rate: 0,
        amount: 0,
        isFloating: false,
        itemTitle: "",
        itemUuid: "",
        deleted: false,
        selectedUnitInPriceList: "",
        unitFlag: false,
    };

    const [rows, setRows] = useState([tempRows]);
    const [loading, setLoading] = useState(false);
    const [wareOptions, setWareOptions] = useState("");
    const [vendorOptions, setVendorOptions] = useState("");
    const [termsOptions, setTermsOptions] = useState("");
    const [itemOptions, setItemOptions] = useState([]);
    const [itemOptions2, setItemOptions2] = useState("");
    const [taxOptions, setTaxOptions] = useState("");
    const [itemLoading, setItemLoading] = useState(false);

    let abortController = null;

    useEffect(() => {
        callBasicAPI();
        if (id) {
            getPurchaseDetails1(id);
        }
        if (billId) {
            getPurchaseDetails1(billId);
        }
    }, []);

    const getPurchaseDetails1 = (Id) => {
        getPurchaseDetails(Id).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                let itemList = res.responsePacket.items;
                let a = res.responsePacket.address;
                let wId = d.warehouseId;
                let pId = d.priceListId;
                handleGetVendor(wId);
                let sub1 = 0;
                itemList?.map((a) => {
                    sub1 = sub1 + a.amount;
                });
                if (Number(sub1).toFixed(2) !== Number(d.subTotalAmount).toFixed(2)) {
                    toast.error("subtotal mismatch");
                }

                d.address?.map((a) => {
                    if (a.addressType === "Billing") {
                        d.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        d.shipAdd = a;
                    }
                });

                getVendorDetails(d.vendorId).then((res) => {
                    if (res.errorCode === 0) {
                        let d1 = res.responsePacket;

                        let custGst12 = d1.gstNumber?.substring(0, 2);
                        let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);

                        let custGst = d1.gstNumber;

                        let customerAddress;
                        d1.addressList.map((item) => {
                            if (item.addressType === "Billing") {
                                customerAddress = item.state;
                            }
                        })
                        if (custGst === "00UNREG0000U0RD") {
                            if (customerAddress === orgState) {
                                handleGetItems(wId, pId, "intra", itemList, d?.vendorTitle);
                                getIntraStateTaxKeyValueList().then((res) => {
                                    const options = res.responsePacket?.map(
                                        (a) => ({
                                            label: a.title,
                                            value: a.recordId,
                                            rate: a.rate,
                                            taxType: a.taxType,
                                        })
                                    );
                                    setTaxOptions(options);
                                });
                            } else {
                                handleGetItems(wId, pId, "inter", itemList, d.vendorTitle);
                                getInterStateTaxKeyValueList().then((res) => {
                                    const options = res.responsePacket?.map(
                                        (a) => ({
                                            label: a.title,
                                            value: a.recordId,
                                            rate: a.rate,
                                            taxType: a.taxType,
                                        })
                                    );
                                    setTaxOptions(options);
                                });
                            }
                        } else {
                            if (custGst12 === orgGst12) {
                                handleGetItems(wId, pId, "intra", itemList, d?.vendorTitle);
                                getIntraStateTaxKeyValueList().then((res) => {
                                    const options = res.responsePacket?.map(
                                        (a) => ({
                                            label: a.title,
                                            value: a.recordId,
                                            rate: a.rate,
                                            taxType: a.taxType,
                                        })
                                    );
                                    setTaxOptions(options);
                                });
                            } else {
                                handleGetItems(wId, pId, "inter", itemList, d.vendorTitle);
                                getInterStateTaxKeyValueList().then((res) => {
                                    const options = res.responsePacket?.map(
                                        (a) => ({
                                            label: a.title,
                                            value: a.recordId,
                                            rate: a.rate,
                                            taxType: a.taxType,
                                        })
                                    );
                                    setTaxOptions(options);
                                });
                            }
                        }
                    }
                });

                let vendor1 = {
                    recordId: d.vendorId,
                    title: d.vendorTitle,
                    value: d.vendorId,
                    label: d.vendorTitle,
                    billAdd: d.billAdd,
                    shipAdd: d.shipAdd,

                    addressList: a,
                    phone: d.vendorMobileNumber,
                    itemPriceListTitle: d.priceListTitle,
                    itemPriceListRecordId: d.priceListId,

                    paymentTermRecordId: d.paymentTermsId,
                    paymentTermTitle: d.paymentTermsTitle,
                };

                let warehouse = {
                    value: d.warehouseId,
                    label: d.warehouseTitle,
                };
                let terms = {
                    value: d.termsConditionId,
                    label: d.termsCondition,
                };
                let shipTax = {
                    value: d.shippingChargeTaxId,
                    label: d.shippingChargeTaxTitle,
                    rate: d.shippingChargeTaxRate,
                };
                let netTax = 0;
                itemList?.map((c) => {
                    netTax += c.taxes.amount;
                });
                // note:  d.shippingCharges=netShip
                // so we need to calculate shipCharge i.e without tax

                let shipCharge =
                    d.shippingCharges / (1 + d.shippingChargeTaxRate * 0.01);

                setPurchaseInfo({
                    ...purchaseInfo,
                    vendor: vendor1,
                    warehouse: warehouse,
                    terms: terms,
                    shipTax: shipTax,
                    shipCharge: Number(shipCharge.toFixed(2)),
                    netTax: netTax,
                    reference: d.referenceNo,
                    orderDate: d.purchaseOrderDate,
                    shipDate: d.expectedShipmentDate,
                    notes: d.vendorNote,
                    subTotal: d.subTotalAmount,
                    total: d.totalAmount,
                    netShip: d.shippingCharges,
                    purchaseOrderNo: d?.purchaseOrderNo,
                    purchaseOrderId: d?.recordId,
                    taxType: "",
                });
            } else {
                handleToast(res);
            }
        });
    };

    const handleAddNewRow = () => {
        setRows([...rows, tempRows]);
        handleFilterItems(rows);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
        handleFilterItems(obj);
        handleSubTotal(obj);
    };

    const handleToast = (res) => {
        toast(res.message);
    };

    const callBasicAPI = () => {
        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            } else {
                handleToast(res);
            }
        });

        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options?.map((a) => {
                    setPurchaseInfo({
                        ...purchaseInfo,
                        terms: a,
                    });
                });
                setTermsOptions(options);
            } else {
                handleToast(res);
            }
        });
    };

    const freshVendor = (aa, d1, taxType) => {
        // setItemOptions("");
        // setItemOptions2("");
        setRows([tempRows]);
        setPurchaseInfo({
            ...purchaseInfo,
            taxType: taxType,
            vendor: d1,
            // warehouse: "",
            shipTax: aa[0],
            netTax: 0,
            subTotal: 0,
            netShip: 0,
            shipCharge: 0,
            total: 0,
        });
    };

    const freshWare = (e) => {
        setItemOptions("");
        setItemOptions2("");
        setRows([tempRows]);
        setPurchaseInfo({
            ...purchaseInfo,
            // taxType: taxType,
            vendor: "",
            warehouse: e,
            netTax: 0,
            subTotal: 0,
            netShip: 0,
            shipCharge: 0,
            total: 0,
        });
    };

    const handleVendor = (e) => {
        getVendorDetails(e.value)
            .then((res) => {
                if (res.errorCode === 0) {
                    let d1 = res.responsePacket;
                    setPurchaseInfo({ ...purchaseInfo, vendor: d1 });

                    d1.value = d1.recordId;
                    d1.label = d1.title;

                    if (!d1.gstNumber) {
                        toast.error("vendor GST not found");
                    }

                    d1.addressList?.map((a) => {
                        if (a.addressType === "Billing") {
                            d1.billAdd = a;
                        }
                        if (a.addressType === "Shipping") {
                            d1.shipAdd = a;
                        }
                    });
                    let wId = purchaseInfo.warehouse.value;
                    let pId = d1.itemPriceListRecordId;
                    let custGst12 = d1.gstNumber?.substring(0, 2);
                    let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);

                    let custGst = d1.gstNumber;
                    let customerAddress;
                    d1.addressList.map((item) => {
                        if (item.addressType === "Billing") {
                            customerAddress = item.state;
                        }
                    })
                    // if (custGst === "00UNREG0000U0RD") {
                    if (custGst12 === orgGst12) {
                        getIntraStateTaxKeyValueList().then((res) => {
                            let d = res.responsePacket;
                            const options = d?.map((a) => ({
                                label: a.title,
                                value: a.recordId,
                                rate: a.rate,
                                taxType: a.taxType,
                            }));
                            const aa = options.filter(
                                (c) => c.taxType === "GST" && c.rate === 18.0
                            );
                            setTaxOptions(options);
                            freshVendor(aa, d1, "intra");
                            handleGetItems(wId, pId, "intra");
                        });
                    } else {
                        getInterStateTaxKeyValueList().then((res) => {
                            let d = res.responsePacket;
                            const options = d?.map((a) => ({
                                label: a.title,
                                value: a.recordId,
                                rate: a.rate,
                                taxType: a.taxType,
                            }));
                            const aa = options.filter(
                                (c) => c.taxType === "IGST" && c.rate === 18.0
                            );
                            setTaxOptions(options);
                            freshVendor(aa, d1, "inter");
                            handleGetItems(wId, pId, "inter");
                        });
                    }
                    // } else {
                    //     if (custGst12 === orgGst12) {
                    //         getIntraStateTaxKeyValueList().then((res) => {
                    //             let d = res.responsePacket;
                    //             const options = d?.map((a) => ({
                    //                 label: a.title,
                    //                 value: a.recordId,
                    //                 rate: a.rate,
                    //                 taxType: a.taxType,
                    //             }));
                    //             const aa = options.filter(
                    //                 (c) => c.taxType === "GST" && c.rate === 18.0
                    //             );
                    //             setTaxOptions(options);
                    //             freshVendor(aa, d1, "intra");
                    //             handleGetItems(wId, pId, "intra");
                    //         });
                    //     } else {
                    //         getInterStateTaxKeyValueList().then((res) => {
                    //             let d = res.responsePacket;
                    //             const options = d?.map((a) => ({
                    //                 label: a.title,
                    //                 value: a.recordId,
                    //                 rate: a.rate,
                    //                 taxType: a.taxType,
                    //             }));
                    //             const aa = options.filter(
                    //                 (c) => c.taxType === "IGST" && c.rate === 18.0
                    //             );
                    //             setTaxOptions(options);
                    //             freshVendor(aa, d1, "inter");
                    //             handleGetItems(wId, pId, "inter");
                    //         });
                    //     }
                    // }


                } else {
                    handleToast(res);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleWarehouse = (e) => {
        setPurchaseInfo({ ...purchaseInfo, warehouse: e });
        let pId = purchaseInfo.vendor.itemPriceListRecordId;
        let wId = e.value;
        handleGetItems(wId, pId);
    };

    const handleWarehouse2 = (e) => {
        // setPurchaseInfo({ ...purchaseInfo, warehouse: e });
        let wId = e.value;
        handleGetVendor(wId);
        freshWare(e);
    };

    const handleGetVendor = (wId) => {
        getVendorByWare(wId)
            .then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.recordId,
                        label: d.title,
                    }));
                    setVendorOptions(options);
                } else {
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleGetItems = (wId, pId, taxType1, itemList, vendorTitle) => {
        if (abortController) {
            abortController.abort();
        }

        abortController = new AbortController();
        const { signal } = abortController;

        setItemLoading(true);
        ItemListByWarePrice1(wId, pId, null, signal)
            .then((res) => {
                if (res.errorCode === 0) {
                    let d = res.responsePacket;
                    const options = d?.map((a) => ({
                        value: a.title,
                        label: (
                            <>
                                <div>{a.title}</div>
                                <div>
                                    stock: {a.currentStockQuantity.toFixed(2)} rate:{" "}
                                    {a.purchasePriceValue.toFixed(2)}
                                </div>
                            </>
                        ),
                        itemId: a.recordId,
                        title: a.title,
                        taxes:
                            taxType1 === "inter"
                                ? a.interstateTax
                                : a.intrastateTax,
                        isFloating: a.isFloating,
                        rate: a.purchasePriceValue,
                        units: [
                            // { value: a.itemUnitId, label: a.itemUnitTitle },
                            { value: a.selectedUnitUuidInPriceList, label: a.selectedUnitInPriceList },
                        ],
                        unit1: { value: a.selectedUnitUuidInPriceList, label: a.selectedUnitInPriceList },
                        selectedUnitInPriceList: a.selectedUnitInPriceList,
                        selectedUnitUuidInPriceList: a.selectedUnitUuidInPriceList
                    }));
                    if (itemList) {
                        let tempRows = [];
                        options?.map((a1) => {
                            itemList?.map((c) => {
                                if (a1.itemId === c.itemUuid) {
                                    let obj = {
                                        item: {
                                            label: c.itemTitle,
                                            value: c.itemUuid,
                                        },
                                        unitFlag: vendorTitle === "La Pyramid Hospitalities Pvt Ltd. , vendor" ? true : false,
                                        itemUuid: c.itemUuid,
                                        itemTitle: c.itemTitle,
                                        isFloating: c?.isFloating,
                                        amount: c.amount,
                                        quantity: c.quantity,
                                        taxes: c.taxes,
                                        rate: c.rate,
                                        hsnSac: c.hsnSac,
                                        hsnUuid: c.hsnUuid,
                                        units: a1.units,
                                        unit1: {
                                            value: c?.unitId,
                                            label: c?.unit,
                                        },
                                        unit: c?.unit,
                                        unitId: c?.unitId,
                                        // billBatchBeansList: [
                                        //     defaultItemBatchDetails,
                                        // ],
                                    };
                                    tempRows.push(obj);
                                }
                            });
                        });
                        setRows(tempRows);
                    }
                    setItemLoading(false);
                    setItemOptions(options);
                    setItemOptions2(options);
                } else {
                    handleToast(res);
                }
            })
            .catch((err) => {
                console.error(err)
                toast.error("server error");
                return;
            });
    };

    const handleData = (e, key) => {
        setPurchaseInfo({
            ...purchaseInfo,
            [e.target.name]: e.target.value,
        });
    };

    const handleTerms = (e) => {
        setPurchaseInfo({
            ...purchaseInfo,
            terms: e,
        });
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item.value = e.itemId;
        obj[i].item.label = e.title;
        obj[i].rate = e.rate;
        obj[i].isFloating = e.isFloating;
        obj[i].itemUuid = e.itemId;
        obj[i].itemTitle = e.title;
        obj[i].taxes = e.taxes;
        obj[i].amount = e.rate * obj[i].quantity;
        obj[i].taxes.amount = obj[i].amount * e.taxes.rate * 0.01;
        obj[i].units = e.units;
        obj[i].unit1 = e.unit1
        obj[i].unit1 = e.units[0];
        obj[i].unitFlag = true;
        obj[i].unit = e.unit1.label;
        obj[i].unitId = e.unit1.value;
        // if (purchaseInfo?.vendor?.title === "La Pyramid Hospitalities Pvt Ltd. , vendor") {
        //     const selectedUnit = e?.units.find((item) => item?.label === e?.selectedUnitInPriceList && item.value === e.selectedUnitUuidInPriceList);
        //     obj[i].unit1 = selectedUnit;
        //     obj[i].unitFlag = true;
        //     obj[i].unit = selectedUnit?.label;
        //     obj[i].unitId = selectedUnit?.value;
        // } else {
        //     obj[i].unit1 = e.units[0];
        //     obj[i].unitFlag = false;
        //     obj[i].unit = e.unit1.label;
        //     obj[i].unitId = e.unit1.value;
        // }
        setRows(obj);
        handleSubTotal(obj);
        handleFilterItems(obj);
    };

    const handleFilterItems = (rows) => {
        var send = false;
        var filterOptions = [];
        itemOptions2 && itemOptions2?.map((a) => {
            rows && rows?.map((b) => {
                if (a.itemId === b?.item?.value) {
                    send = true;
                }
            });
            if (!send) {
                filterOptions.push(a);
            }
            send = false;
        });
        setItemOptions(filterOptions);
    };

    const handleUnit = (e, i) => {
        const obj = [...rows];
        obj[i].unit1 = { value: e.value, label: e.label };
        obj[i].unit = e.label;
        obj[i].unitId = e.value;
        setRows(obj);
    };

    const handleQuantity = (e, i) => {
        const obj = [...rows];
        obj[i].quantity = e.target.value;
        obj[i].amount = obj[i].rate * e.target.value;
        obj[i].taxes.amount = obj[i].amount * obj[i].taxes.rate * 0.01;
        setRows(obj);
        handleSubTotal(obj);
    };

    const handleSubTotal = (rows) => {
        let sum2 = 0;
        let netTax = 0;
        let netShip = purchaseInfo.netShip;
        let rows2 = rows.filter((a) => a.item.value !== "");

        rows2 && rows2?.map((data) => {
            netTax += data.taxes.amount;
            sum2 += data.amount;
            setPurchaseInfo({
                ...purchaseInfo,
                netTax: netTax,
                subTotal: sum2.toFixed(2),
                total: (sum2 + netShip + netTax).toFixed(2),
            });
        });
    };

    const handleRate = (e, i) => {
        if (e.target.value >= 1) {
            const obj = [...rows];
            if (!obj[i].isFloating) return;
            obj[i].rate = Number(e.target.value);
            obj[i].amount = obj[i].quantity * Number(e.target.value);
            obj[i].taxes.amount = obj[i].amount * obj[i].taxes.rate * 0.01;
            setRows(obj);
            handleSubTotal(obj);
        }
    };

    const handleShipCharge = (e) => {
        let ShipCharge = Number(e.target.value);
        let netShip =
            ShipCharge + ShipCharge * purchaseInfo?.shipTax?.rate * 0.01;
        let netTotal =
            Number(purchaseInfo.subTotal) + netShip + purchaseInfo.netTax;

        setPurchaseInfo({
            ...purchaseInfo,
            netShip: netShip,
            shipCharge: ShipCharge,
            total: netTotal,
        });
    };

    const handleShipTax = (e) => {
        let netShip = purchaseInfo.shipCharge + purchaseInfo.shipCharge * e.rate * 0.01;
        let netTotal = Number(purchaseInfo.subTotal) + netShip + purchaseInfo.netTax;

        setPurchaseInfo({
            ...purchaseInfo,
            shipTax: e,
            netShip: netShip,
            total: netTotal,
        });
    };

    const handleSave = (e) => {
        if (purchaseInfo.vendor === "") {
            toast("Select vendor");
            return;
        }

        if (purchaseInfo.warehouse === "") {
            toast("Select warehouse");
            return;
        }
        if (purchaseInfo.terms === "") {
            toast("Select terms");
            return;
        }

        setLoading(true);
        rows?.map((a) => {
            if (id) {
                a.deleted = false;
            }
        });

        let rows2 = rows.filter((a) => a.item.value !== "");
        // let _billBatchBeansList = rows.map((a) => a.billBatchBeansList);
        let quantityFlag = false;
        for (let i = 0; i < rows2.length; i++) {
            const element = rows2[i];
            if (element.quantity <= 0) {
                toast.error(`${element.itemTitle} quantity must not be 0`);
                quantityFlag = true;
                break;
            }
        }
        if (quantityFlag) {
            setLoading(false);
            return;
        }
        if (rows2.length === 0) {
            toast("Select item");
            setLoading(false);
            return;
        }
        let netTot = Number(purchaseInfo?.total).toFixed(2);
        let t2 = netTot.toString()?.split(".")[1];
        let rounding;
        if (t2 > 49) {
            netTot = Number(purchaseInfo?.total).toFixed(0);
            let a = 100 - t2;
            rounding = "0." + a;
        } else {
            rounding = "-0." + t2;
            netTot = netTot.toString()?.split(".")[0];
        }
        let sub1 = 0;
        rows2?.map((a) => { sub1 = sub1 + a.amount });
        if (Number(sub1).toFixed(2) !== Number(purchaseInfo?.subTotal).toFixed(2)) {
            toast.error("subtotal mismatch");
            // return;
        }
        let abc = rows2.some((a) => a?.taxes?.taxId);
        if (!abc) {
            toast.error("item Tax mismatch");
            return;
        }
        let purchaseRequest = {
            totalAmount: netTot,
            taxType: purchaseInfo.taxType === "Inter" ? "IGST" : "GST",
            roundOffAmount: Number(rounding),
            roundOffTitle: "Round off to nearest zero",
            roundOffId: 1,

            totalTax: Number(purchaseInfo?.netTax).toFixed(2),
            taxValue: Number(purchaseInfo?.netTax).toFixed(2),
            items: rows2,
            address: purchaseInfo.vendor.addressList,
            vendorId: purchaseInfo.vendor.recordId,
            vendorTitle: purchaseInfo.vendor.title,
            vendorMobileNumber: purchaseInfo.vendor.phone,
            vendorNote: purchaseInfo.notes,
            purchaseOrderStatusEnum: "Confirmed",

            isDelivered: false,
            isPacked: false,
            isShipped: false,
            isDiscountAtTransaction: true,
            isPaid: true,
            isReceived: false,
            isTcs: true,

            expectedShipmentDate: purchaseInfo.shipDate,
            purchaseOrderDate: purchaseInfo.orderDate,
            paymentTermsId: purchaseInfo.vendor.paymentTermRecordId,
            paymentTermsTitle: purchaseInfo.vendor.paymentTermTitle,

            priceListId: purchaseInfo.vendor.itemPriceListRecordId,
            priceListTitle: purchaseInfo.vendor.itemPriceListTitle,

            subTotalAmount: Number(purchaseInfo?.subTotal).toFixed(2),
            termsCondition: purchaseInfo.terms.label,
            termsConditionId: purchaseInfo.terms.value,

            warehouseId: purchaseInfo.warehouse.value,
            warehouseTitle: purchaseInfo.warehouse.label,
            referenceNo: purchaseInfo.reference,

            invoiceNumber: purchaseInfo.invoiceNumber,
            invoiceDate: purchaseInfo.invoiceDate,

            shippingCharges: purchaseInfo?.netShip,
            shippingChargeTaxRate: purchaseInfo?.shipTax?.rate,
            shippingChargeTaxId: purchaseInfo?.shipTax?.value,
            shippingChargeTaxTitle: purchaseInfo?.shipTax?.label,

            purchaseOrderNo: "SO",
            purchaseOrderStatusEnum: "Confirmed",
            // billBatchBeansList: [],
        };
        // setLoading(false);
        // return

        if (billId) {
            purchaseRequest.motorVehicleNo = purchaseInfo.motorVehicleNo;
            purchaseRequest.billNo = "BO";
            purchaseRequest.orderNo = "SO";
            purchaseRequest.purchaseOrderNo = purchaseInfo?.purchaseOrderNo;
            purchaseRequest.purchaseOrderId = purchaseInfo?.purchaseOrderId;
            purchaseRequest.billDate = purchaseInfo?.orderDate;
            purchaseRequest.itemsList = rows2;
        }

        if (directBill) {
            addDirectBillRecord1(purchaseRequest)
                .then((res) => {
                    if (res.errorCode === 0) {
                        navigate("/bills");
                        handleToast(res);
                        setLoading(false);
                    } else {
                        handleToast(res);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    setLoading(false);
                    return;
                });
        } else {
            if (billId) {
                addBillOrder(purchaseRequest)
                    .then((res) => {
                        if (res.errorCode === 0) {
                            navigate("/bills");
                            handleToast(res);
                            setLoading(false);
                        } else {
                            handleToast(res);
                            setLoading(false);
                        }
                    })
                    .catch(() => {
                        toast.error("server error");
                        setLoading(false);
                        return;
                    });
            } else {
                if (id) {
                    updatePurchaseOrder(id, purchaseRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/purchase");
                                handleToast(res);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                } else {
                    addPurchaseOrder(purchaseRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/purchase");
                                handleToast(res);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                }
            }
        }
    };

    const addNewItemBachDetailRow = (i) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];
        let { billBatchBeansList } = requiredRow;
        requiredRow.billBatchBeansList = [
            ...billBatchBeansList,
            defaultItemBatchDetails,
        ];
        setRows(_rows);
    };
    const removeItemBachDetailRow = (i, j) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];
        requiredRow.billBatchBeansList.splice(j, 1);
        setRows(_rows);
    };

    const itemDetailTextChange = (e, i, j) => {
        const { name, value } = e.target;
        const _rows = [...rows];
        const requiredRow = _rows[i];
        let { billBatchBeansList } = requiredRow;
        let requiredItemBatchDetailRow = billBatchBeansList[j];
        const newItemBatchDetailRow = {
            ...requiredItemBatchDetailRow,
            [name]: value,
        };
        billBatchBeansList[j] = billBatchBeansList[j];
        requiredRow.billBatchBeansList[j] = newItemBatchDetailRow;
        setRows(_rows);
    };

    return (
        <>
            <div className="fill list-header d-flex justify-content-between align-items-center bg-white p-3 border-bottom">
                <h3 className="float-left">
                    <ArticleIcon />
                    &nbsp;&nbsp;
                    {directBill ? "DIRECT GRN" : billId ? "NEW BILL" : id ? "EDIT PURCHASE ORDER" : "NEW PURCHASE ORDER"}
                    &nbsp;&nbsp;{purchaseInfo?.purchaseOrderNo}
                </h3>
            </div>

            <div
                className="scroll-y noscroll-x fill body scrollbox"
                style={{ marginLeft: "15px" }}
            >
                <div className="item-creation" autoComplete="off">
                    <div className="primary-info white-bg">
                        <div className="item-new">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Warehouse
                                        </label>
                                        <div className="col-lg-5">
                                            <Select
                                                onChange={(e) => handleWarehouse2(e)}
                                                isDisabled={wareOptions ? false : true}
                                                options={wareOptions}
                                                value={purchaseInfo.warehouse}
                                            />
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Vendor
                                        </label>
                                        <div className="col-lg-5">
                                            <Select
                                                isDisabled={purchaseInfo.warehouse && vendorOptions ? false : true}
                                                onChange={(e) => handleVendor(e)}
                                                options={vendorOptions}
                                                value={purchaseInfo.vendor}
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Order Date
                                        </label>
                                        <div className="col-lg-5">
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                type="date"
                                                name="orderDate"
                                                onChange={(e) => handleData(e)}
                                                value={purchaseInfo.orderDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Shipment Date
                                        </label>
                                        <div className="col-lg-5">
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                type="date"
                                                name="shipDate"
                                                onChange={(e) => handleData(e)}
                                                value={purchaseInfo.shipDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Terms
                                        </label>
                                        <div className="col-lg-5">
                                            <Select
                                                onChange={(e) => handleTerms(e)}
                                                options={termsOptions}
                                                value={purchaseInfo.terms}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    {purchaseInfo?.vendor?.addressList ? (
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td style={{ minWidth: "100px" }} >Billing:</td>
                                                    <td>{purchaseInfo?.vendor?.billAdd?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td>Shipping:</td>
                                                    <td>{purchaseInfo?.vendor?.shipAdd?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td>PriceList:</td>
                                                    <td>{purchaseInfo?.vendor?.itemPriceListTitle}</td>
                                                </tr>
                                                <tr>
                                                    <td>Pay Terms:</td>
                                                    <td>{purchaseInfo?.vendor?.paymentTermTitle}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <br />
                        <hr />
                        <div className="customTable">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td>Sno.</td>
                                        <td style={{ minWidth: "100px" }}>
                                            Item
                                        </td>
                                        {/* <td>Requested Qty</td>
                                        <td>Received Qty</td> */}
                                        <td>Qty</td>
                                        <td style={{ width: "150px" }}>Unit</td>

                                        <td>Pack Rate</td>
                                        <td>Tax</td>
                                        <td>TaxAmt</td>
                                        <td>Amount</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows ? rows?.map((data, i) => {
                                        return (
                                            <Fragment key={i}>

                                                <tr>
                                                    <td>
                                                        <div className={itemLoading ? "spinner-loader" : ""}></div>
                                                    </td>
                                                    <td>{i + 1}</td>

                                                    <td
                                                        style={{ minWidth: "250px" }}
                                                    >
                                                        <Select
                                                            isDisabled={itemOptions ? false : true || itemLoading}
                                                            style={{ zIndex: "20", }}
                                                            placeholder="Item"
                                                            options={itemOptions}
                                                            value={data?.item}
                                                            onChange={(e) => handleItem(e, i)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            autoComplete="off"
                                                            type="number"
                                                            min={1}
                                                            value={data?.quantity}
                                                            onChange={(e) => handleQuantity(e, i)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select
                                                            options={data?.units}
                                                            value={data?.unit1}
                                                            isDisabled={true}
                                                            onChange={(e) => handleUnit(e, i)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            autoComplete="off"
                                                            type="number"
                                                            value={data?.rate}
                                                            onChange={(e) => handleRate(e, i)}
                                                            disabled={!data?.isFloating}
                                                        />
                                                    </td>
                                                    <td>
                                                        {data.taxes?.title}
                                                    </td>
                                                    <td>
                                                        {data.taxes?.amount?.toFixed(2)}
                                                    </td>
                                                    <td>
                                                        {data.amount?.toFixed(2)}
                                                    </td>
                                                    <td
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleClear(data.item.value, i)}
                                                    >
                                                        <i className="fa fa-times"></i>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        );
                                    })
                                        : null}
                                </tbody>
                            </table>
                        </div>

                        <button
                            id="ember1426"
                            className="btn btn-default addbtn mt-3"
                            onClick={handleAddNewRow}
                        >
                            <AddIcon style={{ color: "blue" }} /> New Row
                        </button>

                        <br />
                        <br />
                        <div className="row justify-content-between">
                            <div className="col-lg-4">
                                <table className="customTable w-100">
                                    <tbody>
                                        <tr>
                                            <td>Notes</td>
                                            <td>
                                                <textarea
                                                    className="form-control"
                                                    name="notes"
                                                    onChange={(e) =>
                                                        handleData(e)
                                                    }
                                                    value={purchaseInfo.notes}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Reference</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    name="reference"
                                                    onChange={(e) =>
                                                        handleData(e)
                                                    }
                                                    value={
                                                        purchaseInfo.reference
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-2 d-lg-block d-none"></div>
                            <div className="col-lg-6">
                                <table className="customTable w-100">
                                    <tbody>
                                        <tr>
                                            <td>Subtotal</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {Number(purchaseInfo?.subTotal).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Shipping [HSN: 996511]:</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    value={purchaseInfo.shipCharge}
                                                    onChange={(e) => handleShipCharge(e)}
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    onChange={(e) => handleShipTax(e)}
                                                    options={taxOptions}
                                                    value={purchaseInfo.shipTax}
                                                    isDisabled={itemOptions ? false : true}
                                                />
                                            </td>
                                            <td>
                                                {Number(purchaseInfo?.netShip).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Total Tax</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {Number(purchaseInfo?.netTax).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {Number(
                                                    purchaseInfo?.total
                                                ).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="text-left mt-3 mb-4">
                            {loading ? (
                                <Button
                                    variant="contained"
                                // onClick={handleSave}
                                >
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Toaster />
        </>
    );
};

export default PurchaseNew;
